<template>
  <app-view @open="onOpen" @restore="onRestore" @close="onClose">
    <list v-if="value.length>0" ref="list" :loadNextPage="loadNext" :clear="clear">
      <div class="result">
        <div class="notFound" v-if="searchOnce && bookshelf.length===0">没有找到相关内容</div>
        <template v-else>
          <movie-cover v-for="(item,index) in bookshelf" :key="index" :value="item" event="selected" @selected="onSelected"></movie-cover>
        </template>
      </div>
    </list>
    <div class="history" v-else>
      <a href="javascript:;" v-for="(item,index) in history" :key="index" @click="onSearch(item)">{{item}}</a>
    </div>
    <div class="input fixedTop">
      <div>
        <i class="icon icon-search"></i>
        <input v-model="value" v-focus placeholder="请输入关键字">
        <a href="javascript:;" class="icon icon-clear" @click="onClearText"></a>
      </div>
    </div>
  </app-view>
</template>
<script>
import AppView from '../components/AppView.vue'
import MovieCover from '../components/MovieCover.vue'
import List from '../components/List.vue'

export default {
  components: { AppView, MovieCover, List },
  data() {
    return {
      history: [],
      value: '',
      timeout: false,
      searchOnce: false
    }
  },
  computed: {
    bookshelf() {
      return this.$service.movie.bookshelf
    },
    query() {
      return this.$service.movie.searchQuery
    },
    first() {
      return this.$route.query.key
    }
  },
  watch: {
    value(val) {
      if (val) {
        if (!this.timeout) {
          this.timeout = true
          setTimeout(() => {
            this.onSearch(this.value)
            this.timeout = false
          }, 1000)
        }
      } else {
        this.clear()
      }
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    }
  },
  mounted() {
    console.info('---', this.first)
    if (this.first) {
      this.value = this.first
      this.onSearch(this.first)
    }
  },
  methods: {
    onSearch(value) {
      if (this.query !== value) {
        this.value = value
        this.$service.movie.searchQuery = value
        if (value) {
          this.$nextTick(() => {
            this.$refs.list.reload()
          })
        }
      }
    },
    onClearText() {
      this.value = ''
      this.$service.movie.searchQuery = ''
      this.searchOnce = false
    },
    clear() {
      this.$service.movie.clearBookShelf()
    },
    async loadNext() {
      await this.$service.movie.searchBookShelf()
      this.searchOnce = true
    },
    onSelected(item) {
      this.$service.user.addSearchHistory(item.title)
      this.$router.push({
        name: 'movie',
        params: {
          movid: item.movid
        }
      })
    },
    onOpen() {
      this.history = this.$service.user.getSearchHistory()
    },
    onRestore() {
      this.value = this.query
      this.history = this.$service.user.getSearchHistory()
    },
    onClose() {
      this.clear()
      this.$service.movie.searchQuery = ''
    }
  }
}
</script>
<style scoped lang='scss'>
.view {
  padding-top: 44px;
  .input {
    display: block;
    background-color: $color-white;
    padding: 8px $app-padding;
    border-bottom: $style-border;
    > div {
      display: flex;
      align-items: center;
      height: 100%;
      line-height: 28px;
      padding-left: $app-padding;
      padding-right: 6px;
      color: $thirdly-text-color;
      border-radius: 28px;
      background-color: $color-back;
      input {
        flex: 1;
        margin-left: 5px;
        color: $primary-text-color;
      }
    }
  }
  .result {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    padding: rem(6);
    .notFound {
      flex: 1;
      text-align: center;
      padding-top: 50px;
      color: $thirdly-text-color;
    }
    > a {
      margin: rem(6);
    }
  }
  @media screen and (min-width: 768px) {
    .result {
      padding: rem(3);
      > a {
        margin: rem(3.5);
      }
    }
  }

  @media screen and (min-width: 1024px) {
    .result {
      padding: rem(3);
      > a {
        margin: rem(2.5);
      }
    }
  }
  .history {
    padding: $app-padding;
    a {
      display: inline-block;
      margin-right: 20px;
      color: $color-blue;
      text-decoration: underline;
      line-height: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?bb8952be